import React from "react";
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Button from '@material-ui/core/Button';
import {RouteComponentProps, withRouter} from 'react-router-dom'
import LoginDialog from "./LoginDialog";
import {userLogout} from "../store/user/actions";
import {thunkUserLogin} from "../store/thunks";
import {UserState} from "../store/user/types";
import {AppState} from "../store";
import {connect} from "react-redux";
import {WithTranslation, withTranslation} from "react-i18next";
import {createStyles, Theme, withStyles, WithStyles} from "@material-ui/core";
import hamaLogo from "./hama-logo-21.png";
import {compose} from "redux";


type HeaderProps = RouteComponentProps & WithTranslation & WithStyles & {
    thunkUserLogin: any,
    userLogout: typeof userLogout,
    user: UserState,
}

interface IHeaderState {
    showLoginDialog: boolean;
}

const styles = ({palette, spacing}: Theme) => createStyles({
    buttonContainer: {
        display: 'flex',
        flexGrow: 1,
        justifyContent: 'flex-end',
        alignItems: 'center'
    },
    btn: {
        textTransform: 'none'
    }
});

class SowHeader extends React.Component <HeaderProps, IHeaderState> {

    state = {
        showLoginDialog: false,
    };

    onTabSelected = (event: React.ChangeEvent<{}>, value: any): void => {
        this.doSelectTab(value);
    };

    doSelectTab = (value: any): void => {
        this.props.history.push(value);
    }

    onLogout = (event: React.MouseEvent<HTMLElement, MouseEvent>): void => {
        this.props.userLogout(this.props.user.user ? this.props.user.user.login : '');
        this.doSelectTab('/app/home');
    }

    openLoginDialog = () => {
        this.setState({showLoginDialog: true});
    }

    onRegistration = (url: string) => {
        window.open(url, "_blank")
    }

    closeLoginDialog = (cancel: boolean, username: string, password: string) => {
        this.setState({showLoginDialog: false});
    }

    showUserProfile = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
        this.doSelectTab('/app/profile');
    }

    getSelectedTab = () => {
        let paths = this.props.location.pathname.split("/");
        if (paths.length < 3) {
            return '/app/home'
        } else {
            return '/' + paths[1] + '/' + paths[2];
        }
    }

    public render() {
        let t = this.props.t;
        let loggingButton;
        if (this.props.user.isLoggedIn) {
            loggingButton =
                <Button color="inherit"
                        onClick={this.onLogout}
                        className={this.props.classes.btn}>{t('Header.logout')}</Button>
        } else {
            loggingButton =
                <Button color="inherit" onClick={this.openLoginDialog}
                        className={this.props.classes.btn}>{t('Header.login')}</Button>
        }
        return (
            <div>
                <div>
                    <AppBar position="static">
                        <Toolbar variant="dense">
                            <img src={hamaLogo} width="4%" height="auto"/>
                            <Tabs value={this.getSelectedTab()}
                                  onChange={this.onTabSelected}>
                                <Tab label={<strong>{t('Header.title')}</strong>} value="/app/home"
                                     className={this.props.classes.btn}/>
                                {this.props.user.isLoggedIn && this.hasRole("reach") &&
                                <Tab label="Reach" value="/app/reach" className={this.props.classes.btn}/>}
                                {this.props.user.isLoggedIn && this.hasRole("eutr") &&
                                <Tab label="Eutr" value="/app/eutr" className={this.props.classes.btn}/>}
                                {this.props.user.isLoggedIn &&
                                <Tab label="Info" value="/app/info" className={this.props.classes.btn}/>}
                                {this.props.user.isLoggedIn && this.hasRole("viewer") &&
                                <Tab label="Viewer" value="/app/viewer" className={this.props.classes.btn}/>}
                                {this.props.user.isLoggedIn &&
                                <Tab label="Profile" value="/app/profile" className={this.props.classes.btn}/>}
                                {this.props.user.isLoggedIn && this.hasRole("admin") &&
                                <Tab label="Admin" value="/app/admin" className={this.props.classes.btn} />}
                            </Tabs>
                            <div className={this.props.classes.buttonContainer}>
                                {this.props.user.isLoggedIn &&
                                <Button
                                    className={this.props.classes.btn}
                                    color="inherit"
                                    onClick={this.showUserProfile}>
                                    {this.props.user.user ? this.props.user.user.firstName + ' ' + this.props.user.user.lastName : ''}
                                </Button>
                                }
                                {!this.props.user.isLoggedIn && 
                                <Button 
                                    color="inherit" 
                                    onClick={() => this.onRegistration(t('Header.registrationURL'))} 
                                    className={this.props.classes.btn}>
                                    {t('Header.registration')}
                                </Button>
                                }
                                {loggingButton}
                            </div>
                        </Toolbar>
                    </AppBar>
                </div>
                <LoginDialog open={this.state.showLoginDialog} t={t}
                             closeDialog={this.closeLoginDialog}/>
            </div>
        );
    }

    hasRole(role: string): boolean {
        let roles = this.props.user.user ? this.props.user.user.roles ? this.props.user.user.roles : new Array<string>() : new Array<string>();
        if (roles.indexOf('viewer') > -1 && role !== 'admin') {
            return true;
        }
        return roles.indexOf(role) > -1;
    }
}

const mapStateToProps = (state: AppState) => ({
    user: state.user
});

export default compose(
    withTranslation('common'),
    withStyles(styles),
    withRouter,
    connect(
        mapStateToProps,
        {thunkUserLogin, userLogout}
    )
)(SowHeader) as any;